import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyConstructionDto, PropertyCreationStep, PropertyDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../property-section-reminder/property-section-reminder.component';
import { PropertyConstructionDisplayComponent } from '../display/construction-display.component';
import { PropertyConstructionFormComponent } from '../form/construction-form.component';

@Component({
  selector: 'etxe-property-construction-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyConstructionDisplayComponent,
    PropertyConstructionFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './construction-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyConstructionEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.CONSTRUCTION),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyConstructionDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyConstructionDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
